module.exports = __webpack_public_path__ + "static/img/save_as.b5ec1790.jpg";